
import { useState } from 'react'
import { Button } from '@/components/ui/button'
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'
import { FileText, Plus } from 'lucide-react'

export const CMSContentEditor = () => {
  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-2">
          <FileText className="w-5 h-5" />
          <p className="text-gray-600">Éditez le contenu de vos sections</p>
        </div>
        <Button className="bg-gradient-to-r from-pink-500 to-blue-500">
          <Plus className="w-4 h-4 mr-2" />
          Nouvelle Section
        </Button>
      </div>

      <div className="grid gap-4">
        <Card>
          <CardHeader>
            <CardTitle>Section Hero</CardTitle>
          </CardHeader>
          <CardContent>
            <p className="text-gray-600">Configuration de la section hero en cours de développement...</p>
          </CardContent>
        </Card>

        <Card>
          <CardHeader>
            <CardTitle>Section À Propos</CardTitle>
          </CardHeader>
          <CardContent>
            <p className="text-gray-600">Configuration de la section à propos en cours de développement...</p>
          </CardContent>
        </Card>

        <Card>
          <CardHeader>
            <CardTitle>Section Services</CardTitle>
          </CardHeader>
          <CardContent>
            <p className="text-gray-600">Configuration de la section services en cours de développement...</p>
          </CardContent>
        </Card>
      </div>
    </div>
  )
}
